import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { GalleryGrid } from './components/GalleryGrid';
import { GalleryLayout } from './components/GalleryLayout';
import { VariantCell } from './components/variants/VariantCell';
import { biGalleryCategory } from './fixtures/biGalleryCategories';
import { useBackToGallery } from './functions/useBackToGallery';

/** One gallery category: every variant, on fixture data. */
export const BiChartCategoryPage = wrapNavigatorScreen(
  ({ category: key }: { category: string }) => {
    const back = useBackToGallery();
    const category = biGalleryCategory(key);
    return (
      <GalleryLayout title={category?.name ?? 'BI 图表样式库'} onBack={back}>
        {({ width, palette }) =>
          category ? (
            <GalleryGrid
              width={width}
              items={category.variants}
              keyOf={variant => variant.key}
              render={(variant, cell) => (
                <VariantCell variant={variant} palette={palette} width={cell} />
              )}
            />
          ) : (
            <CardNotice text={`没有「${key}」这个分类。`} />
          )
        }
      </GalleryLayout>
    );
  },
  { title: 'BI 图表样式库', headerShown: false, headerMode: 'float' },
);
